// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IpOVB","col":"styles_col__1Wx7R"};